// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__7dIj9","footer__listOfIcons":"Footer_footer__listOfIcons__2j-h3","footer__cv":"Footer_footer__cv__2Pm9O","footer__legal":"Footer_footer__legal__2Do3B"};